module.exports = __webpack_public_path__ + "img/austria-cerebrovascular-disease-female.666cb7f7.png";